export enum FileTypeEnum {
  icon = 'icon',
  document = 'document',
  image = 'image'
}
